import BaseApi, { FetchMethodType } from 'api/BaseApi';

export interface ILexisNexisSettings {
  clientOrganizationId: string;
}

export interface ILexisNexisSession {
  sessionId: string;
}

export interface ILexisNexisApi {
  getSettings(): Promise<ILexisNexisSettings | null>;
  createSession(): Promise<ILexisNexisSession>;
}

export default class LexisNexisRestApi
  extends BaseApi
  implements ILexisNexisApi
{
  public async getSettings(): Promise<ILexisNexisSettings | null> {
    const { settings } = await this.fetch<{ settings: ILexisNexisSettings | null }>(
      '/lexis-nexis/settings',
    );

    return settings;
  }

  public async createSession(): Promise<ILexisNexisSession> {
    return this.fetch<ILexisNexisSession>('/lexis-nexis/sessions', {
      method: FetchMethodType.POST,
    });
  }
}
